<template>
  <div
    class="tooltip" :class="{ active: tooltip.active }"
    :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px', width: tooltip.width + 'px' }">
    <div class="arrow"></div>
    <div class="content" :class="{ center: !tooltip.right, right: tooltip.right }">
      <span v-html="_[tooltip.content]"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['tooltip'])
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.tooltip {
  position: absolute;
  top: 50%;
  left: -4px;
  > .content {
    position: absolute;
    top: -5px;
    background: rgba(0,0,0,0.5);
    text-align: center;
    color: #ffffff;
    padding: 8px 12px;
    min-width: 80px;
    white-space: nowrap;
    border-radius: 5px;
    pointer-events: none;
    z-index: 9900;
    &.center {
      left: 50%;
      transform: translateX(-50%) translateY(-100%);
    }
    &.right {
      right: 6px;
      transform: translateX(0) translateY(-100%);
    }
  }
  > .arrow {
    content: '';
    position: absolute;
    top: -5px;
    left: 50%;
    width: 12px;
    transform: translateX(-50%);
    border-width: 4px 6px 0 6px;
    border-style: solid;
    border-color: rgba(0,0,0,0.5) transparent transparent transparent;
    z-index: 99;
  }
}
</style>